import { render } from "./SendMailForm.vue?vue&type=template&id=28d71f6b&scoped=true"
import script from "./SendMailForm.vue?vue&type=script&lang=ts"
export * from "./SendMailForm.vue?vue&type=script&lang=ts"

import "./SendMailForm.vue?vue&type=style&index=0&id=28d71f6b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-28d71f6b"

export default script